import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
//import { AnyAaaaRecord } from 'node:dns';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IMessageDetails, IReceiptDownloadDetails } from '../class/largereceipt';
import { LargereceiptService } from '../service/largereceipt.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedReceiptDownloadDetailsResolver implements Resolve<IReceiptDownloadDetails> {
  constructor(private largeReceiptSvc: LargereceiptService,private router:Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IReceiptDownloadDetails> {
    let historyId = route.paramMap.get('historyId');
    
    
        if (historyId=='undefined') {
            
          // this.router.navigate(['/ErrorPage','Please enter valid History id']);
          this.router.navigate(['/download-authenticated-receipt']);
            return of (null);
        }
        else{
          localStorage.setItem("HistoryId",historyId);
          return this.largeReceiptSvc.isAuthenticatedReceiptDownloadedOrNot(historyId)
          .pipe(
            catchError(error => {
              let errorDescription=error;
              this.router.navigate(['/errorpage',error]);
                return of(null);
            })
          );
        }
  }
}
